"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FlatSaleCallbackBanne = require("./FlatSaleCallbackBanne");
Object.keys(_FlatSaleCallbackBanne).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FlatSaleCallbackBanne[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FlatSaleCallbackBanne[key];
    }
  });
});